import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { API_URL } from '../utils/api';

/// Popup gambar promosi di beranda — diatur admin (menu Popup Beranda).
/// Tampil setiap kali halaman Beranda dibuka (tak ada memori "sudah pernah
/// ditutup" — sesuai permintaan: muncul tiap kali diakses/refresh). Klik
/// gambar membuka tautan yang diset admin di tab baru.
const HomePopupModal = () => {
  const [popup, setPopup] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let active = true;
    fetch(`${API_URL}/api/public/home-popup`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!active || !data?.enabled || !data.imageUrl) return;
        setPopup(data);
        setOpen(true);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!popup || !open) return null;

  const handleImageClick = () => {
    if (popup.linkUrl) window.open(popup.linkUrl, '_blank', 'noopener,noreferrer');
    setOpen(false);
  };

  return (
    <div
      className="fixed inset-0 z-[100] grid place-items-center bg-black/70 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      onClick={() => setOpen(false)}
    >
      <div className="relative max-h-[85vh] max-w-md" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Tutup"
          className="absolute -right-2 -top-2 grid h-9 w-9 place-items-center rounded-full bg-white text-gray-700 shadow-lg transition hover:scale-105 dark:bg-[#1A182E] dark:text-gray-200"
        >
          <X size={18} />
        </button>
        <img
          src={popup.imageUrl}
          alt="Informasi STIKES Harapan Ibu Jambi"
          onClick={handleImageClick}
          className={`max-h-[85vh] w-full rounded-2xl object-contain shadow-2xl ${popup.linkUrl ? 'cursor-pointer' : ''}`}
        />
      </div>
    </div>
  );
};

export default HomePopupModal;
